import React, { useState, useEffect } from "react";
import { SHARED_ROUTES } from "../../config/routes";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Tab, TabList, TabPanel, TabPanels, Tabs, Box } from "@chakra-ui/react";
import Spinner from "../../components/FormElements/Spinner";
import { getOffices } from "../../features/location/officeSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { OfficeWeekView } from "../../Bookings/components/OfficeWeekView";
import RegStudent from "./RegisteredStudent";
import { AlertDialog } from "../../components/UIElements/AlertDialog";
import "../../../src/components/Admin/Admin.css";

export const AdminWeekView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); // Initialize useNavigate
  const location = useLocation();

  const { offices, isLoading, isError } = useSelector((state) => state.office);

  const searchParams = new URLSearchParams(location.search);
  const locationId = searchParams.get("locationId");

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [showStudentList, setShowStudentList] = useState(true);

  useEffect(() => {
    dispatch(getOffices())
      .then(unwrapResult)
      .then((result) => {
        if (locationId && result) {
          // Find the index of the office that matches the locationId
          const foundIndex = result.findIndex(
            (office) => office.location_id === Number(locationId)
          );
          if (foundIndex !== -1) {
            setActiveTabIndex(foundIndex); // Set the active tab based on locationId
          }
        }
      })
      .catch((error) => {
        console.error("GetOffices Dispatch Error: ", error);
      });
  }, [dispatch, locationId]);

  const handleTabChange = (index) => {
    setActiveTabIndex(index);
    setShowStudentList(false);

    // When switching tabs from student list, navigate to /home and pass office location data
    const selectedOffice = offices[index];
    const searchParams = new URLSearchParams({
      locationId: selectedOffice.location_id

    });
    navigate(`${SHARED_ROUTES.home}?${searchParams.toString()}`);
  };

  if (isLoading) return <Spinner />;
  if (isError)
    return <AlertDialog variant="error" message="Error loading office list" />;
  if (!offices || !offices.length) return <Spinner />;

  return (
    <Box maxWidth="1300px" margin="auto" className="responsive-page-content">
      <Tabs
        colorScheme="red"
        fontWeight="bold"
        onChange={handleTabChange} // Handle tab switch
        index={activeTabIndex}  // Keep track of the active tab index
      >
        <TabList>
          {offices.map((office) => (
            <Tab key={office.location_id}>{office.location_name}</Tab>
          ))}
        </TabList>
        <TabPanels>
          {offices.map((office, index) => (
            <TabPanel bg="white" mb="2em" key={office.location_id}>
              {index === activeTabIndex && showStudentList ? (
                <RegStudent
                  locationID={office.location_id}
                  locationName={office.location_name}
                />
              ) : (
                <OfficeWeekView
                  locationId={office.location_id}
                  name={office.location_name}
                />
              )}
            </TabPanel>
          ))}
        </TabPanels>
      </Tabs>
    </Box>
  );
};
